import type { GetCurrentWeather } from '@/shared/domain'
import { mapWeatherResponse } from '@/shared/infra/mappers'
import type { HttpGet } from '@/shared/infra/http'

type WeatherResponseData = Parameters<typeof mapWeatherResponse>[0]

export class WeatherGetCurrentWeatherRepository {
  constructor(private readonly httpClient: HttpGet) {}

  execute: GetCurrentWeather = async ({ lat, lng }) => {
    const data = await this.httpClient.get<WeatherResponseData>({
      url: `/weather-api?lat=${lat}&lng=${lng}`,
    })
    return mapWeatherResponse(data)
  }
}
